import createRequest from './createRequest';

const http = createRequest('https://api.zhizhiyaya.cn');
//const http = createRequest('https://stage-api.zhizhiyaya.cn:32215');

export default http;
